import React from 'react';
import { Box, Grid, Link, Typography } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import { COLOR_GREY_800 } from 'src/utils/colors';

const TooltipContent = ({ tooltipConfig, selectedCompsCount, ltmDateRange }) => {
  return (
    <Grid container spacing={2} direction="column">
      {/* Title and Time Period Row */}
      <Grid item>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h6" fontWeight="bold">
              {tooltipConfig.name}
            </Typography>
          </Grid>
          <Grid item>
            {tooltipConfig.timePeriod && (
              <Typography
                variant="caption"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                <EventIcon fontSize="small" />{' '}
                {tooltipConfig.timePeriod && tooltipConfig.timePeriod == 'ltm'
                  ? ltmDateRange
                  : tooltipConfig.timePeriod}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>

      {/* Definition */}
      <Grid item>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {tooltipConfig.definition.length > 0 &&
            tooltipConfig.definition.map((line, index) => (
              <Typography key={index} variant="body2">
                {line}
              </Typography>
            ))}
        </Box>
      </Grid>

      {/* Helping URLs */}
      {tooltipConfig.helpingUrls && (
        <Grid item>
          {tooltipConfig.helpingUrls.map((url, index) => (
            <Typography variant="body2" sx={{ fontWeight: 'normal' }} key={index}>
              {url.text}
              <Link href={url.ctaURL} target="_blank" rel="noreferrer" sx={{ fontWeight: 'bold' }}>
                {url.ctaText}
              </Link>
            </Typography>
          ))}
        </Grid>
      )}

      {/* Calculation Section */}
      {tooltipConfig.formula && (
        <Grid item>
          <Typography
            variant="subtitle2"
            gutterBottom
            sx={{ fontWeight: 'bold', borderBottom: `1px solid ${COLOR_GREY_800}`, pb: 0.5 }}
          >
            Calculation:
          </Typography>
          <Typography variant="body2">{tooltipConfig.formula}</Typography>
        </Grid>
      )}

      {/* Source */}
      {tooltipConfig.source && (
        <Grid item>
          <Typography variant="caption">
            *Source: {tooltipConfig.source.replace(' n ', ' ' + selectedCompsCount + ' ')}
          </Typography>
        </Grid>
      )}

      {/* Call to Action Link */}
      <Grid item>
        <Box mt={1}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'normal' }}>
            {tooltipConfig?.ctaTextPrefix || ''}{' '}
            <Link
              href={tooltipConfig.ctaURL}
              target="_blank"
              rel="noopener"
              sx={{ fontWeight: 'bold', textDecoration: 'none', color: 'primary.main' }}
            >
              {tooltipConfig.ctaText}
            </Link>
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default TooltipContent;
